import ptBrInvestor from './investor/pt-br';
import enUsInvestor from './investor/en-us';

export default {
  'pt-BR': ptBrInvestor,
  'en-US': enUsInvestor,
};
